import { Outlet, createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/w/$workspaceId/forms')({ component: Outlet });
